import { SearchInput } from "@/ui/inputs/Input";
import React, { useEffect, useRef, useState } from "react";
import useTableService from "../useTableServerSide";
import { Dimmer } from "../spinner";
import Footer from "../Footer";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Pie } from "react-chartjs-2";
import { PrimaryButton } from "@/ui/buttons/Button";
import { ActualizarProveedor } from "./modalActualizarProveedor";

export default function TablaProveedores(props) {
  const op = require("@/modulos/datos");
  const ip = localStorage.getItem("ip");
  const mac = localStorage.getItem("mac");
  const idusuario = localStorage.getItem("idusuario");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [proveedor, setProveedor] = useState();
  const [persona, setPersona] = useState();
  const [clasificador, setClasificador] = useState({
    codigo: "000",
    actividad: "",
    porcentaje: "0,00",
  });
  const [ciudad, setCiudad] = useState();
  const [municipio, setMunicipio] = useState();
  const [estadoT, setEstadoT] = useState();
  const [estado, setEstado] = useState();
  const [tcontribuyente, setTcontribuyente] = useState();
  const [comercio, setComercio] = useState();
  const [denominacion, setDenominacion] = useState();
  const [showModal, setShowModal] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [grafica, setGrafica] = useState([]);
  const [totales, setTotales] = useState({
    total: 0,
    activos: 0,
    inactivos: 0,
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cardsData = [
    {
      title: "Proveedores REGISTRADOS",
      value: totales.total || 0,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Proveedores ACTIVOS",
      value: totales.activos || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
    {
      title: "Proveedores INACTIVOS",
      value: totales.inactivos || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
    },
  ];

  const headCells = [
    {
      id: "idproveedor",
      label: "ID",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "razonsocial",
      label: "DESCRIPCIÓN",
      width: "400px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "rif",
      label: "RIF",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "responsable",
      label: "CEDULA",
      width: "80",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "180px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const chartLabels = [
    "Bienes y Servicios",
    "Contratista de Obras",
    "Fondo Terceros",
    "Organismos",
    "Beneficiario",
  ];

  const generateColors = (count) => {
    const colors = ["#E74C3C", "#2ECC71", "#3498DB", "#F39C12", "#9B59B6"];
    return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
  };

  const backgroundColors = generateColors(chartLabels.length);
  const chartValues = Object.values(grafica);

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Distribución por Actividad",
        data: grafica,
        backgroundColor: backgroundColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,0.8)",
        padding: 10,
        cornerRadius: 4,
      },
    },
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  // Cargar catálogos necesarios para la modal
  const cargarCatalogos = async () => {
    try {
      const [resDenom, resEstado, resTcontrib] = await Promise.all([
        axios.get(`${op.conexion}/api/catalogo/denominacioncomercial`, {
          headers: { "x-access-token": `${token}` },
        }),
        axios.get(`${op.conexion}/api/catalogo/estado`, {
          headers: { "x-access-token": `${token}` },
        }),
        axios.get(`${op.conexion}/api/catalogo/tipocontribuyente`, {
          headers: { "x-access-token": `${token}` },
        }),
      ]);

      if (resDenom.status === 200) setDenominacion(resDenom.data);
      if (resEstado.status === 200) setEstado(resEstado.data);
      if (resTcontrib.status === 200) setTcontribuyente(resTcontrib.data);
    } catch (error) {
      console.error("Error cargando catálogos:", error);
    }
  };

  const buscarRegistrosProveedor = () => {
    setLoading(true);
    const campos = `idproveedor,razonsocial,rif,responsable, status,actprincipal`;
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "proveedor",
      orden: "idproveedor desc",
    };
    const endpoint = `${op.conexion}/api/administracion/buscar-proveedores`;
    const controller = new AbortController();

    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { rows, count, totales } = response.data;
          setRecords(rows);
          setTotalRecords(count);
          setTotales({
            total: totales.total,
            activos: totales.activos,
            inactivos: totales.inactivo,
          });
          const valoresMapeados = [
            totales.total_bienes || 0,
            totales.total_contratista || 0,
            totales.total_fondo || 0,
            totales.total_organizacion || 0,
            totales.total_beneficiario || 0,
          ];
          setGrafica(valoresMapeados);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };

  const buscarProveedor = async ({ idProveedor }) => {
    setLoading(true);
    try {
      const resProveedor = await axios.get(
        `${op.conexion}/api/administracion/seleccionarproveedor/${idProveedor}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataProv = resProveedor.data;
      setProveedor(dataProv);
      const resPerson = await axios.get(
        `${op.conexion}/api/consulta/modeli?campos=*&id=${dataProv.responsable}&nomtab=persona&nomid=cedula`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      setPersona(resPerson.data);
      if (dataProv.clasifisrl && dataProv.clasifisrl !== "000") {
        const resClasif = await axios.get(
          `${op.conexion}/api/consulta/modeli?campos=*&id=${dataProv.clasifisrl}&nomtab=tablaretencionislr&nomid=codigo`,
          {
            headers: { "x-access-token": `${token}` },
          },
        );
        if (resClasif.status === 200) {
          setClasificador(resClasif.data);
        }
      } else {
        setClasificador({ codigo: "000", actividad: "", porcentaje: "0,00" });
      }

      // Obtener ciudad, municipio y estado en una sola consulta
      if (dataProv.ciudad) {
        const resCiudad = await axios.get(
          `${op.conexion}/api/consulta/modeli?campos=c.idciudad, row_to_json(c.*) as ciudad, row_to_json(m.*) as municipio, row_to_json(e.*) as estado&id=${dataProv.ciudad}&nomtab=ciudad c inner join municipio m on m.idmunicipio = c.idmunicipio inner join estado e on e.idestado = m.idestado&nomid=idciudad`,
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        const dataCiudad = resCiudad.data;
        setCiudad(dataCiudad.ciudad);
        setEstadoT(dataCiudad.estado);
        setMunicipio(dataCiudad.municipio);
      }

      // Obtener comercio si existe
      if (dataProv.idcomercio) {
        try {
          const resComercio = await axios.get(
            `${op.conexion}/api/consulta/modeli?campos=*&id=${dataProv.idcomercio}&nomtab=comercio&nomid=idcomercio`,
            {
              headers: { "x-access-token": `${token}` },
            },
          );
          if (resComercio.status === 200 && resComercio.data.idcomercio > 0) {
            setComercio(resComercio.data);
          }
        } catch (error) {
          console.error("Error cargando comercio:", error);
        }
      }

      setShowModal(true);
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del proveedor",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Limpiar estado de la modal al cerrar
  const cerrarModal = () => {
    setShowModal(false);
    blanquear();
  };

  const blanquear = () => {
    setProveedor();
    setPersona();
    setClasificador({ codigo: "000", actividad: "", porcentaje: "0,00" });
    setCiudad();
    setMunicipio();
    setEstadoT();
    setComercio();
    setOperacion(0);
  };

  useEffect(() => {
    cargarCatalogos();
    const cleanup = buscarRegistrosProveedor();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);

  const cerrar = () => {
    props.menu?.();
  };

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-3 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        <div className="col-9">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white d-flex justify-content-between">
              <h5 className="mb-0 fw-bold text-uppercase">
                Gestion de Proveedores
              </h5>
              <a
                type="button"
                className="text-light fw-bold fs-6"
                onClick={cerrar}
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-times ms-2" />
              </a>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <div className="col-auto mx-2 p-0">
                  <PrimaryButton
                    icon="fa-plus m-0 p-0"
                    onClick={() => {
                      blanquear();
                      setOperacion(1);
                      setShowModal(true);
                    }}
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "50px",
                            }}
                          >
                            {item.idproveedor}
                          </td>
                          <td style={{ fontSize: "12px", textAlign: "left" }}>
                            {item.razonsocial}
                          </td>
                          <td style={{ fontSize: "12px", textAlign: "center" }}>
                            {item.rif}
                          </td>
                          <td style={{ fontSize: "12px", textAlign: "center" }}>
                            {item.responsable}
                          </td>
                          <td
                            align="center"
                            className="align-baseline"
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              width: "180px",
                              padding: 0,
                            }}
                          >
                            <button
                              className="btn btn-sm btn-info rounded-circle"
                              onClick={() => {
                                setOperacion(4);
                                buscarProveedor({
                                  idProveedor: item.idproveedor,
                                });
                              }}
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-warning rounded-circle mx-2 my-1"
                              onClick={() => {
                                setOperacion(2);
                                buscarProveedor({
                                  idProveedor: item.idproveedor,
                                });
                              }}
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-danger rounded-circle"
                              onClick={() => {
                                setOperacion(3);
                                buscarProveedor({
                                  idProveedor: item.idproveedor,
                                });
                              }}
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>

        <div className="col-3">
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                align="center"
                mb={1}
                color="text.secondary"
                style={{ textTransform: "uppercase" }}
              >
                Tipo de Proveedor
              </Typography>

              <Box
                sx={{
                  flex: 1,
                  position: "relative",
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Pie data={chartData} options={chartOptions} />
              </Box>

              <Box
                sx={{ flexGrow: 0, overflowY: "auto", maxHeight: "40%", mt: 1 }}
              >
                <List dense sx={{ py: 0 }}>
                  {chartLabels.map((label, index) => (
                    <React.Fragment key={label}>
                      <ListItem
                        sx={{ px: 1, py: 0.5 }}
                        secondaryAction={
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                          >
                            {chartValues[index]}
                          </Typography>
                        }
                      >
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            backgroundColor: backgroundColors[index],
                            mr: 2,
                            flexShrink: 0,
                          }}
                        />
                        <ListItemText
                          style={{ textTransform: "uppercase" }}
                          primaryTypographyProps={{
                            variant: "caption",
                            noWrap: true,
                            sx: { fontSize: "11px" },
                          }}
                          primary={label}
                        />
                      </ListItem>
                      {index < chartLabels.length - 1 && (
                        <Divider component="li" />
                      )}
                    </React.Fragment>
                  ))}
                </List>
              </Box>
            </CardContent>
          </Card>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />

      {/* Modal con todos los parámetros completos */}
      <ActualizarProveedor
        show={showModal}
        declaWeb={false}
        proveedor={proveedor}
        persona={persona}
        clasif={clasificador}
        estadoT={estadoT}
        estado={estado}
        comercio={comercio}
        tcontribuyente={tcontribuyente}
        municipioT={municipio}
        ciudadT={ciudad}
        ip={ip}
        mac={mac}
        denominacion={denominacion}
        idusuario={idusuario}
        operacion={operacion}
        onHideRenderizar={buscarRegistrosProveedor}
        onHideCancela={cerrarModal}
      />

      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
